// Vendor
import * as React from 'react';
import { SPOT_BRAND } from '@thredup/styleguide/src/variables/colors';

// Internal
import { SVGProps } from './types';

interface IconArrowProps extends SVGProps {
  direction?: string;
}

/**
 * @name IconArrow
 * @description Arrow Icon
 */
const IconArrow: React.FC<IconArrowProps> = (props) => {
  const {
    className,
    desc,
    direction,
    fill,
    height = 28,
    id,
    title,
    width = 10
  } = props;

  // const downDirection = `translate(${width},${height}) rotate(180)`;
  // const rightDirection = `translate(${width},${height}) rotate(90)`;
  let transform = '';
  switch (direction) {
    case 'down':
      transform = `translate(${width},${height}) rotate(180)`;
      break;
    case 'right':
      transform = `translate(${width / 2},${height / 2}) rotate(90)`;
      break;
    default:
      break;
  }

  return (
    <svg
      aria-labelledby={id}
      className={className}
      height={height}
      role="img"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id={id}>{title}</title>
      <desc>{desc}</desc>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform={transform}
      >
        <g
          transform="translate(-354.000000, -643.000000)"
          fill={fill}
          fillRule="nonzero"
        >
          <path d="M363.733845,647.340603 L359.720642,643.250707 C359.531249,643.080534 359.284685,642.991012 359.032102,643.000714 L359.032102,643.000714 C358.77065,642.999177 358.519355,643.103524 358.333726,643.290706 L354.281177,647.350603 C353.906274,647.739436 353.906274,648.361733 354.281177,648.750567 L354.281177,648.750567 C354.465911,648.947577 354.721658,649.05952 354.98939,649.060559 C355.242644,649.059534 355.485751,648.959242 355.668093,648.780566 L355.75662,648.680569 L358.048474,646.360628 L358.018965,670.000025 C358.018965,670.552296 358.45935,671 359.002593,671 L359.002593,671 C359.545836,671 359.986221,670.552296 359.986221,670.000025 L359.986221,646.340628 L362.31742,648.720568 C362.565169,648.97422 362.927208,649.074235 363.267161,648.982939 C363.607113,648.891643 363.873333,648.622905 363.965537,648.277957 C364.057741,647.933009 363.961921,647.564256 363.714172,647.310604 L363.733845,647.340603 Z"></path>
        </g>
      </g>
    </svg>
  );
};

IconArrow.defaultProps = {
  desc: 'Arrow Icon',
  direction: 'up',
  fill: SPOT_BRAND,
  height: 28,
  id: 'thredup-arrow-icon',
  title: 'Arrow',
  width: 10
};

export { IconArrow };
